import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { AgentInstructions } from "../../types";

/** What a person has before their first save: no row, and nothing written. */
export const NO_AGENT_INSTRUCTIONS: AgentInstructions = {
  body: "",
  version: 0,
  changed_by: null,
  updated_at: null,
};

export async function fetchAgentInstructions(): Promise<AgentInstructions> {
  const { data, error } = await supabase
    .from("agent_instructions")
    .select("body, version, changed_by, updated_at")
    .maybeSingle();
  if (error) throw error;
  return (data as AgentInstructions | null) ?? NO_AGENT_INSTRUCTIONS;
}

export function useAgentInstructions() {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.agentInstructions,
    queryFn: fetchAgentInstructions,
    enabled: !!user,
  });
}
